/**
 * Filter Constants for Splinterlands Cards
 * Centralizes all filter definitions used across the application
 */

// Card Elements (Splinter/Mana types)
export const CARD_ELEMENTS = [
  { 
    id: 'fire', 
    name: 'Fire', 
    color: 'Red',
    activeIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_fire.svg',
    inactiveIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_fire_inactive.svg'
  },
  { 
    id: 'water', 
    name: 'Water', 
    color: 'Blue',
    activeIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_water.svg',
    inactiveIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_water_inactive.svg'
  },
  { 
    id: 'earth', 
    name: 'Earth', 
    color: 'Green',
    activeIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_earth.svg',
    inactiveIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_earth_inactive.svg'
  },
  { 
    id: 'life', 
    name: 'Life', 
    color: 'White',
    activeIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_life.svg',
    inactiveIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_life_inactive.svg'
  },
  { 
    id: 'death', 
    name: 'Death', 
    color: 'Black',
    activeIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_death.svg',
    inactiveIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_death_inactive.svg'
  },
  { 
    id: 'dragon', 
    name: 'Dragon', 
    color: 'Gold',
    activeIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_dragon.svg',
    inactiveIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_dragon_inactive.svg'
  },
  { 
    id: 'neutral', 
    name: 'Neutral', 
    color: 'Gray',
    activeIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_neutral.svg',
    inactiveIcon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_element_neutral_inactive.svg'
  }
];

// Card Rarities
export const CARD_RARITIES = [
  {
    id: 'common',
    name: 'Common',
    value: 1,
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/create_team/icon_rarity_common_new.svg'
  },
  {
    id: 'rare',
    name: 'Rare',
    value: 2,
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/create_team/icon_rarity_rare_new.svg'
  },
  {
    id: 'epic',
    name: 'Epic',
    value: 3,
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/create_team/icon_rarity_epic_new.svg'
  },
  {
    id: 'legendary',
    name: 'Legendary',
    value: 4,
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/create_team/icon_rarity_legendary_new.svg'
  }
];

// Helper function to get rarity info by value
export const getRarityInfoByValue = (rarityValue) => {
  return CARD_RARITIES.find(rarity => rarity.value === rarityValue) || CARD_RARITIES[0];
};

// Helper function to get element info by color
export const getElementInfoByColor = (color) => {
  const colorMap = {
    'Red': 'fire',
    'Blue': 'water', 
    'Green': 'earth',
    'White': 'life',
    'Black': 'death',
    'Gold': 'dragon',
    'Gray': 'neutral'
  };
  
  const elementId = colorMap[color];
  return CARD_ELEMENTS.find(element => element.id === elementId) || null;
};

// Helper function to get card type info by value
export const getCardTypeInfoByValue = (typeValue) => {
  return CARD_TYPES.find(type => type.value === typeValue) || null;
};

// Card Editions
// These match the edition IDs returned from the API
export const CARD_EDITIONS = [
  { id: 21, name: 'Verico', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-verico.svg', color: '#8B4513' },
  { id: 20, name: 'Escalation', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-mini-set.svg', color: '#00BFA5' },
  { id: 19, name: 'Land', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-land.svg', color: '#8B4513' },
  { id: 18, name: 'Conclave Rewards', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-reward.svg', color: '#00BFA5' },
  { id: 17, name: 'Extra', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-extra.svg', color: '#9C27B0' },
  { id: 15, name: 'Foundations', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-foundations.svg', color: '#9C27B0' },
  { id: 14, name: 'Conclave Arcana', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-conclave-arcana.svg', color: '#00BFA5' },
  { id: 13, name: 'Soulbound Reb', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-soulbound.svg', color: '#FF4C00' },
  { id: 12, name: 'Rebellion', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-rebellion.svg', color: '#FF8E00' },
  { id: 10, name: 'Soulbound', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-soulbound.svg', color: '#FF4C00' },
  { id: 8, name: 'Riftwatchers', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-rift.svg', color: '#2ACAEA' },
  { id: 7, name: 'Chaos Legion', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-chaos.svg', color: '#F50239' },
  { id: 5, name: 'Dice', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-dice.svg', color: '#FF2F45' },
  { id: 4, name: 'Untamed', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-untamed.svg', color: '#74FA5C' },
  { id: 3, name: 'Reward', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-reward.svg', color: '#316099' },
  { id: 2, name: 'Promo', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-promo.svg', color: '#67696B' },
  { id: 1, name: 'Beta', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-beta.svg', color: '#8A379C' },
  { id: 0, name: 'Alpha', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-alpha.svg', color: '#CA9C00' }
];

// Foil types
export const CARD_FOILS = [
  {
    id: 0,
    name: 'Regular',
    color: '#CCCCCC'
  },
  {
    id: 1,
    name: 'Gold Foil',
    color: '#FFD700'
  },
  {
    id: 2,
    name: 'Gold Arcana',
    color: '#FFA500'
  },
  {
    id: 3,
    name: 'Black Foil',
    color: '#333333'
  },
  {
    id: 4,
    name: 'Black Arcana',
    color: '#4B0082'
  }
];

// Gold card status
export const CARD_GOLD_STATUS = [
  {
    id: 'regular',
    name: 'Regular',
    value: false
  },
  {
    id: 'gold',
    name: 'Gold',
    value: true,
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/gold.png'
  }
];

// Helper function to get dynamic edition data from API
export const loadEditionsFromApi = async () => {
  try {
    const response = await fetch('https://api.splinterlands.com/settings');
    const data = await response.json();
    
    if (data && Array.isArray(data.editions)) {
      const apiEditions = data.editions.map(edition => {
        // Find our predefined edition with matching ID
        const predefinedEdition = CARD_EDITIONS.find(e => e.id === edition.id);
        
        return {
          id: edition.id,
          name: edition.name,
          // Use our predefined icons and colors if available, otherwise fallback
          icon: predefinedEdition?.icon || null,
          color: predefinedEdition?.color || '#888888'
        };
      });
      
      // Sort by our predefined order (Conclave Arcana first, Alpha last)
      return apiEditions.sort((a, b) => {
        const orderA = CARD_EDITIONS.findIndex(e => e.id === a.id);
        const orderB = CARD_EDITIONS.findIndex(e => e.id === b.id);
        return orderA - orderB;
      });
    }
    return CARD_EDITIONS; // Fallback to predefined editions
  } catch (error) {
    console.error("Error loading editions from API:", error);
    return CARD_EDITIONS; // Fallback to predefined editions
  }
};

// Utility function to get edition name by ID
export const getEditionNameById = (editionId) => {
  const edition = CARD_EDITIONS.find(ed => ed.id === editionId);
  return edition ? edition.name : 'Unknown';
};



// Card Bloodlines (Sub Types)
export const CARD_BLOODLINES = [
  { id: 'avian', name: 'Avian', value: 'Avian' },
  { id: 'awakened_beast', name: 'Awakened Beast', value: 'Awakened Beast' },
  { id: 'bruteborn', name: 'Bruteborn', value: 'Bruteborn' },
  { id: 'canisan', name: 'Canisan', value: 'Canisan' },
  { id: 'celestial', name: 'Celestial', value: 'Celestial' },
  { id: 'chimeric_beast', name: 'Chimeric Beast', value: 'Chimeric Beast' },
  { id: 'corrupted', name: 'Corrupted', value: 'Corrupted' },
  { id: 'dhampir', name: 'Dhampir', value: 'Dhampir' },
  { id: 'divine_construct', name: 'Divine Construct', value: 'Divine Construct' },
  { id: 'djinn', name: 'Djinn', value: 'Djinn' },
  { id: 'dragon', name: 'Dragon', value: 'Dragon' },
  { id: 'drakoshan', name: 'Drakoshan', value: 'Drakoshan' },
  { id: 'dwarf', name: 'Dwarf', value: 'Dwarf' },
  { id: 'elemental', name: 'Elemental', value: 'Elemental' },
  { id: 'elf', name: 'Elf', value: 'Elf' },
  { id: 'feliform', name: 'Feliform', value: 'Feliform' },
  { id: 'fey', name: 'Fey', value: 'Fey' },
  { id: 'fiend', name: 'Fiend', value: 'Fiend' },
  { id: 'fungoid', name: 'Fungoid', value: 'Fungoid' },
  { id: 'giant', name: 'Giant', value: 'Giant' },
  { id: 'gnome', name: 'Gnome', value: 'Gnome' },
  { id: 'goblin', name: 'Goblin', value: 'Goblin' },
  { id: 'golem', name: 'Golem', value: 'Golem' },
  { id: 'halfling', name: 'Halfling', value: 'Halfling' },
  { id: 'human', name: 'Human', value: 'Human' },
  { id: 'llamataur', name: 'Llamataur', value: 'Llamataur' },
  { id: 'lycanthrope', name: 'Lycanthrope', value: 'Lycanthrope' },
  { id: 'materran', name: 'Materran', value: 'Materran' },
  { id: 'minotaur', name: 'Minotaur', value: 'Minotaur' },
  { id: 'mundane_beast', name: 'Mundane Beast', value: 'Mundane Beast' },
  { id: 'orc', name: 'Orc', value: 'Orc' },
  { id: 'plant', name: 'Plant', value: 'Plant' },
  { id: 'rodentian', name: 'Rodentian', value: 'Rodentian' },
  { id: 'saurian', name: 'Saurian', value: 'Saurian' },
  { id: 'skitterkin', name: 'Skitterkin', value: 'Skitterkin' },
  { id: 'suidae', name: 'Suidae', value: 'Suidae' },
  { id: 'tideborn', name: 'Tideborn', value: 'Tideborn' },
  { id: 'tortisian', name: 'Tortisian', value: 'Tortisian' },
  { id: 'treefolk', name: 'Treefolk', value: 'Treefolk' },
  { id: 'ulund', name: 'Ulund', value: 'Ulund' },
  { id: 'undead', name: 'Undead', value: 'Undead' }
];

// Card Types (Units/Monsters vs Archons/Summoners)
export const CARD_TYPES = [
  {
    id: 'units',
    name: 'Units',
    value: 'Monster',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_filter_units.svg'
  },
  {
    id: 'archons',
    name: 'Archons',
    value: 'Summoner',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/collection/icon_filter_archons.svg'
  }
];

// Utility function to get bloodline name by value
export const getBloodlineNameByValue = (subType) => {
  const bloodline = CARD_BLOODLINES.find(bl => bl.value === subType);
  return bloodline ? bloodline.name : subType || 'Unknown';
};

// Utility function to get card type name by value
export const getCardTypeNameByValue = (type) => {
  const cardType = CARD_TYPES.find(ct => ct.value === type);
  return cardType ? cardType.name : type || 'Unknown';
};

// Hierarchical Card Sets (like Splinterlands Market)
// Each set has categories with their respective tier and is_promo flags
export const CARD_SETS = [
  {
    id: 'conclave_arcana',
    name: 'Conclave Arcana',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-conclave-arcana.svg',
    color: '#00BFA5',
    categories: [
      { id: 'core', name: 'Core', tier: 14, isPromo: false, editions: '14', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-conclave-arcana.svg' },
      { id: 'escalation', name: 'Escalation', tier: 14, isPromo: false, editions: '20', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-mini-set.svg' },
      { id: 'promo', name: 'Promo', tier: 14, isPromo: true, editions: '2', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-promo.svg' },
      { id: 'extra', name: 'Extra', tier: 14, isPromo: false, editions: '17', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-extra.svg' },
      { id: 'reward', name: 'Reward', tier: 14, isPromo: false, editions: '18', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-reward.svg' }
    ]
  },
  {
    id: 'rebellion',
    name: 'Rebellion',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-rebellion.svg',
    color: '#FF8E00',
    categories: [
      { id: 'core', name: 'Core', tier: 12, isPromo: false, editions: '12', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-rebellion.svg' },
      { id: 'promo', name: 'Promo', tier: 12, isPromo: true, editions: '2', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-promo.svg' },
      { id: 'reward', name: 'Reward', tier: 12, isPromo: false, editions: '13', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-reward.svg' }
    ]
  },
  {
    id: 'foundations',
    name: 'Foundations',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-foundations.svg',
    color: '#9C27B0',
    categories: [
      { id: 'core', name: 'Core', tier: 15, isPromo: false, editions: '15,16', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-foundations.svg' },
      { id: 'extra', name: 'Extra', tier: 15, isPromo: false, editions: '17', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-extra.svg' }
    ]
  },
  {
    id: 'chaos_legion',
    name: 'Chaos Legion',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-chaos.svg',
    color: '#F50239',
    categories: [
      { id: 'core', name: 'Core', tier: 7, isPromo: false, editions: '7', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-chaos.svg' },
      { id: 'promo', name: 'Promo', tier: 7, isPromo: true, editions: '2', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-promo.svg' },
      { id: 'reward1', name: 'Reward 1', tier: 7, isPromo: false, editions: '3', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-reward.svg' },
      { id: 'reward2', name: 'Reward 2', tier: 7, isPromo: false, editions: '10', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-soulbound.svg' },
      { id: 'riftwatchers', name: 'Riftwatchers', tier: 7, isPromo: false, editions: '8', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-rift.svg' }
    ]
  },
  {
    id: 'untamed',
    name: 'Untamed',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-untamed.svg',
    color: '#74FA5C',
    categories: [
      { id: 'core', name: 'Core', tier: null, isPromo: false, editions: '4', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-untamed.svg' },
      { id: 'promo', name: 'Promo', tier: 4, isPromo: true, editions: '2', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-promo.svg' },
      { id: 'dice', name: 'Dice', tier: 4, isPromo: false, editions: '5', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-dice.svg' },
      { id: 'reward', name: 'Reward', tier: 4, isPromo: false, editions: '3', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-reward.svg' }
    ]
  },
  {
    id: 'beta',
    name: 'Beta',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-beta.svg',
    color: '#8A379C',
    categories: [
      { id: 'core', name: 'Core', tier: null, isPromo: false, editions: '0,1', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-beta.svg' },
      { id: 'promo', name: 'Promo', tier: null, isPromo: false, editions: '2', cardIdRange: [114, 117], icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-promo.svg' },
      { id: 'essence_orb', name: 'Essence Orb', tier: null, isPromo: false, editions: '2', cardIdRange: [118, 129], icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-essence-orb.svg' },
      { id: 'reward', name: 'Reward', tier: null, isPromo: false, editions: '3', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-reward.svg' }
    ]
  },
  {
    id: 'alpha',
    name: 'Alpha',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-alpha.svg',
    color: '#CA9C00',
    categories: [
      { id: 'core', name: 'Core', tier: null, isPromo: false, editions: '0,1', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-alpha.svg' },
      { id: 'promo', name: 'Promo', tier: null, isPromo: false, editions: '2', cardIdRange: [75, 77], icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-promo.svg' }
    ]
  },
  {
    id: 'eternal',
    name: 'Eternal',
    icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-land.svg',
    color: '#8B4513',
    categories: [
      { id: 'land', name: 'Land', tier: 19, isPromo: false, editions: '19', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-land.svg' },
      { id: 'verico', name: 'Verico', tier: 19, isPromo: false, editions: '21', icon: 'https://d36mxiodymuqjm.cloudfront.net/website/icons/icon-edition-verico.svg' }
    ]
  }
];

// Utility function to match card details with selected set categories
export const matchesSetCategory = (cardDetails, category) => {
  if (!cardDetails || !category) return false;
  
  // Check tier first (including null values)
  if (cardDetails.tier !== category.tier) return false;
  
  // Check if is_promo flag matches (if category has isPromo defined)
  if (category.isPromo !== undefined && cardDetails.is_promo !== category.isPromo) return false;
  
  // Check if editions match (if category has editions defined)
  // This is important to distinguish between Core (edition 14), Extra (edition 17), and Escalation (edition 20)
  if (category.editions !== undefined) {
    // Handle multiple editions (e.g., "15,16" for Foundations)
    const categoryEditions = category.editions.split(',').map(e => e.trim());
    const cardEditions = cardDetails.editions ? cardDetails.editions.split(',').map(e => e.trim()) : [];
    
    // Check if any of the card's editions match any of the category's editions
    const hasMatchingEdition = categoryEditions.some(catEd => cardEditions.includes(catEd));
    if (!hasMatchingEdition) return false;
  }
  
  // Check card ID range (for Beta/Alpha Promo vs Essence Orb distinction)
  if (category.cardIdRange !== undefined) {
    const [minId, maxId] = category.cardIdRange;
    if (cardDetails.id < minId || cardDetails.id > maxId) return false;
  }
  
  return true;
};

// Utility function to check if card matches any of the selected categories
export const matchesAnyCategory = (cardDetails, selectedCategories) => {
  if (!selectedCategories || selectedCategories.length === 0) return true;
  
  // Get all category objects from selected category keys
  const categories = [];
  selectedCategories.forEach(categoryKey => {
    CARD_SETS.forEach(set => {
      const category = set.categories.find(cat => `${set.id}_${cat.id}` === categoryKey);
      if (category) {
        categories.push(category);
      }
    });
  });
  
  // Check if card matches any of the categories
  return categories.some(category => matchesSetCategory(cardDetails, category));
};
